import fectx from 'deps/fectx';
import { parseQueryString } from 'utils/url';
import { getConfig } from 'helper/configManager';
import { getAuth } from './configAuth';

const __DEV__ = process.env.NODE_ENV === 'development';
const ENABLE_PROXY = true;

const queryStr = parseQueryString(window.location.search);
const config = getConfig();
const fectxInstance = fectx.create({
  baseURL: __DEV__ && ENABLE_PROXY ? '' : config.apiEndpoint,
  timeout: 5 * 1000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    ApiToken: config.apiToken,
  },
  transformRequest: [data => JSON.stringify(data)],
  validateStatus: _status => _status !== 401 && _status !== 404,
});

fectxInstance.interceptors.request.use(config => {
  const authConfig = getAuth();
  if (config.noAuthor !== true && authConfig.key && authConfig.value) {
    config.headers[authConfig.key] = authConfig.value;
  }

  if (queryStr.UA) {
    config.headers['user-agent'] = queryStr.UA;
  } else if (queryStr.ua) {
    config.headers['user-agent'] = queryStr.ua;
  }

  return config;
});

if (__DEV__ && ENABLE_PROXY) {
  fectxInstance.interceptors.request.use(fectxConfig => {
    fectxConfig.headers['use-proxy'] = 'true';
    fectxConfig.headers['x-proxy-target'] = 'http:' + config.apiEndpoint;
    return fectxConfig;
  });
}
export default fectxInstance;
